import React from 'react';
import './About.css';

const About = () => {
  const technicalHighlights = [
    {
      category: 'Languages & Frameworks',
      icon: '🛠️',
      skills: [
        'Python, Java, .NET, Node.js, React, Flutter, Django, Spring',
        'Jupyter Notebooks, TensorFlow, RDF'
      ]
    },
    {
      category: 'AI & Vector Search',
      icon: '🧠',
      skills: [
        'Prompt engineering and MCP servers',
        'RAG and semantic search, model embeddings, Vector databases (Weaviate, Opensearch)',
        'AI orchestration and agent development(LangChain, LangGraph, LlamaIndex, CrewAI, SwarmsAI)',
        'Evaluation frameworks (Weights & Biases, Arize AI, AWS Guardrails)',
      ]
    },
    {
      category: 'Data Engineering & Databases',
      icon: '💾',
      skills: [
        'RDS, MySQL, PostgreSQL, MongoDB, Cassandra, Redis',
        'BigQuery, Spark, Databricks, PostGIS, Apache Sedona (geospatial)',
      ]
    },
    {
      category: 'Cloud & DevOps',
      icon: '☁️',
      skills: [
        'Multi-cloud architecture (AWS, GCP)',
        'Kubernetes, Docker, Terraform, CloudFormation',
        'CI/CD and streaming data (Kafka) pipelines'
      ]
    },
    {
      category: 'Backend & Architecture',
      icon: '🏗️',
      skills: [
        'Microservices, event-driven architecture and API design',
        'WebSockets, REST, SIP/VOIP/WebRTC (telecom)'
      ]
    }    
  ];


  return (
    <section id="about" className="about">
      <div className="container">
        {/* <h2 className="section-title">About Me</h2> */}
        {/* <p className="section-subtitle">
          Passionate about making AI accessible to developers worldwide
        </p> */}

        <div className="about-content">
          <div className="about-text">
            <h3>My Journey</h3>
            <p>
            Over the past two decades, I’ve built and scaled systems that power millions of daily transactions across gaming, fintech, healthcare, and the public sector. My work has always centered around one goal — making complex technology performant, resilient, and accessible.
            </p>
            <p>
            I began my career as a full-stack developer, working with Java and .NET on early enterprise systems before moving into large-scale backend architecture. From designing multiplayer gaming platforms at Electronic Arts and Sony Supermassive Games to implementing semantic big-data pipelines at MarkLogic, I’ve always been drawn to the intersection of performance engineering and elegant design.
            </p>
            <p>
            As cloud computing evolved, so did my focus — from monolithic architectures to microservices, Kubernetes, and fully serverless environments across AWS, Azure, and GCP. I moved into solution architect and director roles at Twilio, Babylon Health, and PA Consulting — designing infrastructure and learning to bridge technical complexity with C-level communication. I’ve led cross-functional teams, advised C-level stakeholders, and driven technical direction for organizations navigating transformation.
            </p>
            <p>
            Today, I'm focused on production AI — blending vector databases, orchestration frameworks, and modern agentic workflows to enable intelligent, high-performance systems. I remain passionate about bridging innovation and clarity — mentoring teams, contributing to open source, and sharing insights through technical blogs and talks.
            </p>
            <p>
            Outside of work, I’ve co-founded and developed a travel app, created a few games and I stay close to the startup community — often exchanging ideas with founders and engineers who are shaping what’s next.
            </p>
          </div>

          <div className="skills-container">
            <h3>Technical Highlights</h3>
            <div className="technical-highlights">
              {technicalHighlights.map((category, index) => (
                <div key={index} className="tech-category">
                  <div className="tech-category-header">
                    <span className="tech-icon">{category.icon}</span>
                    <h4>{category.category}</h4>
                  </div>
                  <ul className="tech-list">
                    {category.skills.map((skill, i) => (
                      <li key={i}>{skill}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

